
import { View } from 'backbone';
import eventBus         from 'EventBus.js';

import nameTemplate from 'report/properties/main/pie-chart-label.ejs';


class MainPieChartLabelView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = nameTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change #pieLabelsPositions' : 'updateSelectAttributes'
        };

        if (this.model.get('pieLabelsPositions') !== 'inside' && this.model.get('pieLabelsPositions') !== 'none'  ) {
            /* we used to have callout, outside and insideCallout as options, but player tool does not support
            those options. Instead of them, the default option will be inside.  PF-3073.  */
            this.model.set({
                'pieLabelsPositions': 'inside',
                'showPieLabel': true,
                'showPieLegend': false
            }, {silent: true});
        }
        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateSelectAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        this.model.set( propName, propVal );

        // The only 2 options are now "none" and "inside" (PF-3073)
        if (propVal === "none"){
            this.model.set({
                'showPieLabel': false,
                'showPieLegend': false 
            });
        }else if(propVal === "inside" || propVal === "insideCallout"){
            this.model.set({
                'showPieLabel': true,
                'showPieLegend': false 
            });
        }else if(propVal === "outside" || propVal === "outsideCallout"){
            this.model.set({
                'showPieLabel': false,
                'showPieLegend': true 
            });
        }                    
    }


    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));

            $("#pieLabelsPositions option[value='" + this.model.get('pieLabelsPositions') + "']").prop('selected', true);

        }
        this.delegateEvents();
        return this;
    }

}

export default MainPieChartLabelView;
